import React from 'react';
import { ReceivedCasesTable } from './ReceivedCasesTable';
import { SharingUpsell } from './SharingUpsell';

type ReceivedCasesTableProps = React.ComponentProps<typeof ReceivedCasesTable>;

export interface ReceivedCasesPanelProps extends ReceivedCasesTableProps {
    /** The session's effective subscription (includes the admin/dev override). */
    isPro: boolean;
    /** The server's verdict from list-received: the team is not Pro, so it got a count only. */
    proRequired: boolean;
    /** Cases waiting for the team. The only thing a non-Pro team is shown about them. */
    pendingCount: number;
    onUpgradeClick: () => void;
}

/**
 * Received tab body. Receiving is a Pro feature for the receiving team: a non-Pro team sees only
 * how many cases are waiting and the upgrade prompt -- no rows, and so no accept, reject, copy or
 * view buttons. The server enforces the same rule; `proRequired` covers a session whose
 * subscription override says Pro while the team is not.
 */
export const ReceivedCasesPanel: React.FC<ReceivedCasesPanelProps> = ({
    isPro,
    proRequired,
    pendingCount,
    onUpgradeClick,
    ...tableProps
}) => {
    if (!isPro || proRequired) {
        return <SharingUpsell onUpgradeClick={onUpgradeClick} waitingToReceiveCount={pendingCount} />;
    }
    return <ReceivedCasesTable {...tableProps} />;
};
